export default __webpack_public_path__ + "static/media/helen-keller.4cac65e2.png";